import React, {Component} from 'react';
import {
  Panel,
  Row,
  Col,
  FormControl,
  Button,
  HelpBlock
} from 'react-bootstrap';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  GENERATE_PROMOCODE
}                           from 'actions/const';

import Select               from 'react-select';
import                           'react-select/dist/react-select.css';

import axios                from 'axios';
import FileSaver            from 'file-saver';

import saveTrail            from '../../utils/saveTrail';

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class GeneratePromocode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      error: {}
    };

    this.generate = this.generate.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  loadOptions(input, cb, type) {
    var query,
        objItem;

    if (type.toUpperCase() === 'MERCHANT') {
      query = new Parse.Query('Merchant');
      query.select(['name']);

      objItem = (obj) => {
        return {
          value: obj.id,
          label: obj.get('name')
        };
      }
    } else {
      query = new Parse.Query('User');
      query.select(['name']);

      objItem = (obj) => {
        return {
          value: obj.id,
          label: obj.get('name')
        };
      }
    }

    query.matches("name", input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');

    query.limit(20);
    query.ascending("name");

    query.find()
    .then((data) => {
      var options = [];

      if (data.length !== 0) {
        options = data.map(objItem);
      }

      cb(null, {options});
    })
    .catch((err) => {
      console.log('loadOptions error: ', err);
      cb(null, {options: []});
    });
  }

  generate() {
    let {
      couponCode,
      merchant,
      user,
      prefix,
      numberOfCodes,
      length,
      isExclusive
    } = this.props.generatepromocode;

    this.setState({ error: {} });

    if (couponCode === '') {
      this.setState({
        error: {
          couponCode: 'Coupon Code is required.'
        }
      });
    } else if (merchant === null) {
      this.setState({
        error: {
          merchant: 'Merchant is required.'
        }
      });
    } else if (user === null) {
      this.setState({
        error: {
          user: 'User is required.'
        }
      });
    } else if (prefix === '') {
      this.setState({
        error: {
          prefix: 'Prefix is required.'
        }
      });
    } else if (numberOfCodes === '') {
      this.setState({
        error: {
          numberOfCodes: 'Number of codes is required.'
        }
      });
    } else if (length === '') {
      this.setState({
        error: {
          length: 'Length is required.'
        }
      });
    } else if (isExclusive === null) {
      this.setState({
        error: {
          isExclusive: 'Exclusive is required.'
        }
      });
    } else {
      this.setState({ error: {}, isLoading: true });

      axios.post(WEB_PATH + '/GeneratePromocode/generate', {
        couponCode,
        merchantId: merchant.value,
        userId: user.value,
        prefix,
        numberOfCodes,
        length,
        isExclusive: isExclusive.value
      }, {responseType: 'arraybuffer'})
      .then((res) => {
        this.setState({ isLoading: false });

        var blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        FileSaver.saveAs(blob, 'Generated Promo Code.xlsx');

        saveTrail('GENERATE', {
          couponCode,
          merchantId: merchant.value,
          userId: user.value,
          prefix,
          numberOfCodes,
          length,
          isExclusive: isExclusive.value
        });
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log("generate error", err);
      });
    }
  }

  accessible(actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

  render() {
    let {
      isLoading,
      error
    } = this.state;

    let {
      setValue
    } = this.props.actions;

    let {
      couponCode,
      merchant,
      user,
      prefix,
      numberOfCodes,
      length,
      isExclusive
    } = this.props.generatepromocode;

    const space = {
			paddingTop: '10px',
			paddingBottom: '10px'
		};

    const loadingState = {
      display: isLoading ? '' : 'none',
      color: 'white'
    };

    return (
      <Panel>
        <Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
          <h4>Generate Promocode</h4>
        </Panel.Heading>
        <Panel.Body style={{
          padding: '30px 50px 30px 50px'
        }}>
          <Row>
            <Col md={6}>
              <Row style={space}>
                <Col md={4}>
                  Coupon Code
                </Col>
                <Col md={8}>
                  <FormControl
                    type="text"
                    value={couponCode}
                    onChange={(e) => {
                      setValue(GENERATE_PROMOCODE, 'couponCode', e.target.value);
                    }}
                    />
                  <HelpBlock>{error.couponCode}</HelpBlock>
                </Col>
              </Row>
              <Row style={space}>
                <Col md={4}>
                  Merchant
                </Col>
                <Col md={8}>
                  <Select.Async
                    value={merchant}
                    loadOptions={(input, cb) => this.loadOptions(input, cb, 'MERCHANT')}
                    onChange={(val) => {
                      setValue(GENERATE_PROMOCODE, 'merchant', val);
                    }}
                    />
                  <HelpBlock>{error.merchant}</HelpBlock>
                </Col>
              </Row>
              <Row style={space}>
                <Col md={4}>
                  User
                </Col>
                <Col md={8}>
                  <Select.Async
                    value={user}
                    loadOptions={(input, cb) => this.loadOptions(input, cb, 'USER')}
                    onChange={(val) => {
                      setValue(GENERATE_PROMOCODE, 'user', val);
                    }}
                    />
                  <HelpBlock>{error.user}</HelpBlock>
                </Col>
              </Row>
              <Row style={space}>
                <Col md={4}>
                  Prefix
                </Col>
                <Col md={4}>
                  <FormControl
                    type="text"
                    value={prefix}
                    onChange={(e) => {
                      setValue(GENERATE_PROMOCODE, 'prefix', e.target.value);
                    }}
                    />
                  <HelpBlock>{error.prefix}</HelpBlock>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row style={space}>
                <Col md={4}>
                  Number of Codes
                </Col>
                <Col md={4}>
                  <FormControl
                    type="number"
                    value={numberOfCodes}
                    onChange={(e) => {
                      setValue(GENERATE_PROMOCODE, 'numberOfCodes', e.target.value)
                    }}
                    />
                  <HelpBlock>{error.numberOfCodes}</HelpBlock>
                </Col>
              </Row>
              <Row style={space}>
                <Col md={4}>
                  Length
                </Col>
                <Col md={4}>
                  <FormControl
                    type="number"
                    value={length}
                    onChange={(e) => {
                      setValue(GENERATE_PROMOCODE, 'length', e.target.value)
                    }}
                    />
                  <HelpBlock>{error.length}</HelpBlock>
                </Col>
              </Row>
              <Row style={space}>
                <Col md={4}>
                  Exclusive
                </Col>
                <Col md={4}>
                  <Select
                    value={isExclusive}
                    options={[
                      {value: true, label: 'TRUE'},
                      {value: false, label: 'FALSE'}
                    ]}
                    onChange={(val) => {
                      setValue(GENERATE_PROMOCODE, 'isExclusive', val)
                    }}
                    />
                  <HelpBlock>{error.isExclusive}</HelpBlock>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={2} mdOffset={5}>
              <Button
                bsStyle="primary"
                style={{ display: this.accessible('GENERATE') }}
                onClick={() => (this.accessible('GENERATE') === '') ? this.generate() : {} }>
                <i style={loadingState} className="fa fa-spinner fa-spin" />
                Generate
              </Button>
            </Col>
          </Row>
        </Panel.Body>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  let {
    generatepromocode,
    accessjson
  } = state;

  const props = {
    generatepromocode,
    accessjson
  };

  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: generics.setValue
  };

  const actionMap = {
    actions: bindActionCreators(actions, dispatch)
  };

  return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(GeneratePromocode);



// WEBPACK FOOTER //
// ./components/GeneratePromocode/index.js